var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaceContent = function SvgFaceContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 13.8s1.35 1.8 3.6 1.8 3.6-1.8 3.6-1.8m.9-4.284c-.355.437-.841.684-1.35.684-.508 0-.981-.247-1.35-.684m-3.6 0c-.355.437-.841.684-1.35.684-.508 0-.981-.247-1.35-.684M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFaceContent;